import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { TextAreaFormField } from '~/shared/forms/controls/fields/text-fields/TextAreaFormField';
import { DisciplineEnum, DisciplineOptions, InterventionTypeOptions } from '@generated';
import { DatePickerFormField } from '~/shared/forms/controls/fields/date-fields/DatePickerFormField';
import { SingleButtonGroupFormField } from '~/shared/forms/controls/fields/button-groups/SingleButtonGroupFormField';
import { DisciplineChipButton } from '~/libraries/disciplines/DisciplineChipButton';
import { useForm } from '~/shared/forms/FormContext';

export function CustomInterventionFormFields() {
	const { formHelpers } = useForm();
	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-col gap-4">
				<div className="flex flex-row gap-4">
					<TextFormField name="subject" className="w-[350px]" />
					<SingleButtonGroupFormField name="interventionTypeId" label="Intervention Type" options={InterventionTypeOptions} />
				</div>
			</div>
			<div className="w-full max-w-3xl space-y-4">
				<TextAreaFormField name="definitionText" />
			</div>
			<div className="grid grid-cols-5 gap-4 pb-4">
				<DatePickerFormField name="projectedStartDate" />
				<DatePickerFormField name="projectedEndDate" />
				<div className="col-span-2 flex flex-col justify-center">
					<span className="mb-2 block text-xs text-gray-500">{formHelpers.readOnly ? 'Selected' : 'Select'} discipline:</span>
					<div className="flex items-center gap-1.5">
						{DisciplineOptions.toSorted((a, b) => a.id - b.id)
							.filter(x => x.id !== DisciplineEnum.HomeHealthAide)
							.map(discipline => {
								const disciplineOption = DisciplineOptions.find(x => x.id === discipline.id)!;
								return (
									<DisciplineChipButton
										key={discipline.id}
										id={discipline.id}
										abbreviation={disciplineOption.abbreviation}
										selected={formHelpers.values.assignedDisciplineId === discipline.id}
										onClick={() => formHelpers.setFieldValue('assignedDisciplineId', discipline.id, true)}
									/>
								);
							})}
					</div>
				</div>
			</div>
		</div>
	);
}
